import { Component, Vue } from 'vue-property-decorator';

@Component({
    components: {

    },
    // 过滤器 格式化金额
    filters: {
      Money(data: number) {
        return typeof(data) === 'number' ? '+' + data.toFixed(2) : data;
      },
    },
})
export default class RechargeDetails extends Vue {
  private $api: any;
  private rechargeInfo: any = null;
  private rechargelist = [];
  private loading: boolean = false;
  private failed: boolean = false;  // 是否加载失败 

  private checkID() {
    const rechargeInfo = localStorage.getItem('RechargeInfo') || '';
    if (rechargeInfo !== '') {
      this.rechargeInfo = JSON.parse(rechargeInfo); // 本地缓存
      this.getUserRechargeDetails();
    }
    // if (this.$store.state.rechargeInfo != null && this.$store.state.rechargeInfo !== undefined) {
    //   console.log(this.$store.state.rechargeInfo);
    //   this.rechargeInfo = this.$store.state.rechargeInfo;  // vuex
    // }
  }

  private async getUserRechargeDetails() {
    this.loading = true;
    const params = {
      Id : this.rechargeInfo.Id,
    };
    const result = await this.$api.httpPost('Salary/SupermarketRecharge/QueryUserRechargeDetail', params);
    if (result.Success) {
      // console.log(result.Data);
      this.rechargelist = result.Data;
    } else {
      this.failed = true;
    }
    this.loading = false;
  }
  
  // life cycle
  private mounted() {
    this.checkID();
  }

}
